import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {RecommendationsApi} from "../../services/network/recommendation-api";
import {CreateRecommendationRequest} from "../../services/models/recommendation";
import {RECOMMENDATION_ENDPOINTS} from "../../services/network/endpoints";

export function useUpdateRecom() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [RECOMMENDATION_ENDPOINTS.UPDATE],
        mutationFn: async ({id, data}: {id: string, data: Partial<CreateRecommendationRequest> & {file?: File | null}}) => {
            return RecommendationsApi.updateRecommendation(id, data);
        },
        onError() {
            toast.error("Ошибка изменения рекомендации");
        },
        onSuccess: (_, variables) => {
            if (variables?.data?.sector) {
                queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR, variables.data.sector] });
            } else {
                queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR] });
            }
            if (variables?.id) {
                queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.GET, variables.id] });
            }
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.GET_UNREAD_RECOMMS] });
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_SHORT] });
            toast.success("Рекомендация успешно изменена");
        }
    });
}
